import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Text } from '@pixi/react';
import { isMobile } from '../../../../../core/helpers/isMobile';

const PayTableStepInfoText = observer(({ x, y, type, text, align, anchor, wordWrapWidth }) => {
  const handlePayTableInfoTextStyles = useCallback(() => {
    const mainStyles = {
      _align: align,
      fontFamily: 'poppinsMedium',
    };
    if (type === 'title') {
      return { ...mainStyles, _fontWeight: 700, _fontSize: isMobile() ? 30 : 40 };
    }
    if (type === 'subTitle') {
      return { ...mainStyles, _fontWeight: 400, _fill: '#FFFFFF', _fontSize: isMobile() ? 14 : 16 };
    }
    if (type === 'middleText') {
      return {
        ...mainStyles,
        _wordWrap: true,
        _fontWeight: 500,
        _fill: '#FFFFFF',
        _fontSize: isMobile() ? 12 : 14,
        _wordWrapWidth: wordWrapWidth,
      };
    }
    return {
      ...mainStyles,
      _wordWrap: true,
      _fill: '#FFFFFF',
      _fontWeight: 400,
      _wordWrapWidth: wordWrapWidth,
      _fontSize: isMobile() ? 14 : 16,
    };
  }, [type, align, wordWrapWidth]);

  return (
    <Container name='PayTableTextContainer'>
      <Text
        x={x}
        y={y}
        text={text}
        resolution={2}
        anchor={anchor || 0}
        style={handlePayTableInfoTextStyles()}
      />
    </Container>
  );
});

export default PayTableStepInfoText;
